import { Metadata } from "next";
import RegisterForm from '@/Component/Auth/Register/RegisterForm'

export const metadata: Metadata = {
    title: "Register | Connector Club",
    description: "",
};

const BrandRegisterPage = () => {
  return (
    <RegisterForm />
  )
}

export default BrandRegisterPage
